<template>
    <p-form @submit="onSubmit" v-if="job" ref="form">
        <div class="container-fluid content-wrapper">
        <b-row class="content-heading">
            <b-col>
                <div>{{ isNew ? 'Add' : 'Edit' }} Data Exchange Job</div>
            </b-col>
            <b-col cols="auto" class="ms-auto">
                <p-button
                    type="submit"
                    variant="primary"
                    :disabled="!isUseFtp"
                    >Save</p-button
                >
            </b-col>
        </b-row>
        <b-row cols="1" cols-lg="4" class="mb-3">
            <b-col>
                <p-select
                    label="Job Action"
                    :options="jobActions"
                    rules="required"
                    v-model="job.parameters.action"
                    @change="clearCriteria()"
                />
            </b-col>
            <b-col>
                <p-select
                    label="Job Type"
                    :options="jobTypesOptions"
                    :disabled="!job.parameters.action"
                    rules="required"
                    v-model="job.parameters.cronJobTypeId"
                />
            </b-col>
            <b-col cols="auto" class="ms-auto d-flex" v-if="!isNew">
                <div class="extra-padding v-center active-toggle">
                    <p-checkbox
                        :use-switch="true"
                        v-model="job.isActive"
                        :label="job.isActive ? 'Active' : 'Inactive'"
                    />
                </div>
                <div class="v-center">
                    <p-button class="mt-2" variant="outline-danger"
                        @click="deleteJob()"
                        >Delete Job</p-button
                    >
                </div>
            </b-col>
        </b-row>
        <p-card>
            <b-row cols="1" cols-lg="2">
                <b-col>
                    <p-input
                        label="Job Name"
                        rules="required|max:50|valid_jobname"
                        v-model="job.name"
                        @input="areParametersDirty = true"
                    />
                </b-col>
            </b-row>
            <b-row cols="1" cols-lg="1">
                <b-col>
                    <p-text-area
                        label="Job Description"
                        rules="required|max:200"
                        v-model="job.description"
                        @input="areParametersDirty = true"
                    />
                </b-col>
            </b-row>
        </p-card>
                <p-card title="Criteria" v-if="job.parameters.action === 'Export' && job.parameters.cronJobTypeId != cronJobTypes.generalLedger && job.parameters.cronJobTypeId != cronJobTypes.stockLedger">
                    <b-row class="pe-2">
                    <b-col class="ps-3 pe-2">
                            <b-form>
                                <b-form-group
                                    label-for="automatic"
                                    class="ms-3 mt-2 me-2"
                                >
                                    <b-form-row>
                                        <b-col>
                                            <b-input-group>
                                                <b-form-input
                                                    name="automatic"
                                                    ref='searchRef'
                                                    type="search"
                                                    placeholder="Search by Transaction ID, Last Name, First Name, Customer Account #, or Serial #"
                                                    debounce="300"
                                                    @keydown.enter.prevent=""
                                                    v-model="job.searchSettings.automatic"
                                                />
                                                <p-select
                                                    class="search-filter search-by-select"
                                                    style="margin-left: 0.5rem !important;"
                                                    :options="filterBy"
                                                    v-model="job.searchSettings.searchBy"
                                                />
                                            </b-input-group>
                                        </b-col>
                                        <slot name="afterSearch"> </slot>
                                    </b-form-row>
                                </b-form-group>
                            </b-form>

                    </b-col>
                </b-row>
                    <b-row class="ps-3 pe-2" cols="1" cols-sm="2" cols-xl="4">
                    <b-col>
                        <p-select
                            label="Location"
                            data-type="locations"
                            noSelectionMessage="All Locations"
                            v-model="job.searchSettings.locationId"
                        />
                    </b-col>
                    <b-col>
                        <p-select
                            label="POS Device"
                            data-type="posDevicesWithLocation"
                            noSelectionMessage="Show All"
                            v-model="job.searchSettings.posDeviceId"
                        />
                    </b-col>
                    <b-col>
                        <p-select
                            label="Cashier"
                            data-type="nbcUsers"
                            noSelectionMessage="Show All"
                            v-model="job.searchSettings.cashierId"
                        />
                    </b-col>
                    <b-col>
                        <p-select
                            label="Transaction Type"
                            :options="transactionTypeOptions"
                            noSelectionMessage="Show All"
                            v-model="job.searchSettings.transactionType"
                        />
                    </b-col>
                    <b-col>
                        <p-select
                            label="Tender"
                            data-type="tenders"
                            noSelectionMessage="Show All"
                            v-model="job.searchSettings.tenderId"
                        />
                    </b-col>
                    <b-col>
                        <p-select
                            label="AR Account / Agency"
                            data-type="accounts"
                            noSelectionMessage="Show All"
                            v-model="job.searchSettings.accountId"
                        />
                    </b-col>                     
                    <b-col>
                        <p-select
                            label="Date Range"
                            data-type="dateOption"
                            v-model="job.searchSettings.dateOption"
                            @change="onDateOptionChange($event)"
                        />
                    </b-col>
                    <b-col>
                        <p-datepicker v-if="job.searchSettings.dateOption == dateOptions.Custom"
                            label="Transaction Date: From"
                            vid="transactionStartDate"
                            v-model="job.searchSettings.fromDate"
                        />
                    </b-col>
                    <b-col>
                        <p-datepicker v-if="job.searchSettings.dateOption == dateOptions.Custom"
                            label="Transaction Date: To"
                            vid="transactionEndDate"
                            rules="dateGreaterOrEqual:@transactionStartDate"
                            is-end-date
                            v-model="job.searchSettings.toDate"
                        />
                    </b-col>
                </b-row>
            </p-card>
            <p-card title="Criteria" v-if="job.parameters.action === 'Export' && (job.parameters.cronJobTypeId == cronJobTypes.generalLedger || job.parameters.cronJobTypeId == cronJobTypes.stockLedger)">
                <b-row class="pe-2">
                    <b-col class="ps-3 pe-2">
                        <b-form>
                            <b-form-group
                                label-for="automatic"
                                class="ms-3 mt-2 me-2">
                                <b-form-row>
                                    <b-col>
                                        <b-input-group>
                                            <b-form-input
                                                name="automatic"
                                                ref='searchRef'
                                                type="search"
                                                placeholder="Search by Journal Number or Description"
                                                debounce="300"
                                                @keydown.enter.prevent=""
                                                v-model="job.searchSettings.automatic" />
                                            <p-select
                                                class="search-filter search-by-select"
                                                style="margin-left: 0.5rem !important;"
                                                :options="ledgerFilterBy"
                                                v-model="job.searchSettings.searchBy" />
                                        </b-input-group>
                                    </b-col>
                                    <slot name="afterSearch"></slot>
                                </b-form-row>
                                <b-form-row>
                                    <b-col>
                                        <p-select
                                            label="Location"
                                            data-type="locations"
                                            noSelectionMessage="All Locations"
                                            v-model="job.searchSettings.locationId"
                                        />
                                    </b-col>
                                    <b-col cols="3">                                        
                                        <p-select
                                            label="Date Range"
                                            data-type="dateOption"
                                            v-model="job.searchSettings.dateOption"
                                            @change="onDateOptionChange($event)"
                                        />
                                    </b-col>
                                    <b-col>
                                        <p-datepicker v-if="job.searchSettings.dateOption == dateOptions.Custom"
                                            label="Date: From"
                                            vid="ledgerStartDate"
                                            v-model="job.searchSettings.fromDate"
                                        />
                                    </b-col>
                                    <b-col>
                                        <p-datepicker v-if="job.searchSettings.dateOption == dateOptions.Custom"
                                            label="Date: To"
                                            vid="ledgerEndDate"
                                            rules="dateGreaterOrEqual:@ledgerStartDate"
                                            is-end-date
                                            v-model="job.searchSettings.toDate"
                                        />
                                    </b-col>
                                </b-form-row>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
            </p-card>
            <p-card title="Transport Method">
            <b-row cols="1" cols-lg="1">
                <b-col class="mt-3 d-flex align-items-center">
                    <b-form-radio-group
                        v-model="job.parameters.transportMethod"
                        @input="areParametersDirty = true"
                    >
                        <b-form-radio :value="1">FTP</b-form-radio>
                        <b-form-radio :value="2">SFTP</b-form-radio>
                        <!-- <b-form-radio :value="3">SCP</b-form-radio> -->
                        <b-form-radio :value="4" v-if="!isNew && job.parameters.action==='Import'"
                            >File Upload</b-form-radio
                        >
                    </b-form-radio-group>
                    <p-checkbox
                        v-if="canRenameFileAfterProcessing"
                        label="Rename file after processing"
                        info-message="After successful transfer and processing the source file will be renamed so future executions of the job will not process the same file again."
                        class="ms-3"
                        v-model="job.parameters.renameFileAfterProcessing"
                    />
                </b-col>
            </b-row>
            <b-row
                cols-lg="4"
                class="mb-2"
                cols="1"
                cols-sm="2"
                cols-xl="4"
                v-if="isUseFtp"
            >
                <b-col>
                    <p-input
                        label="FTP Address"
                        :rules="isUseFtp ? 'required|max:200' : ''"
                        v-model="job.parameters.ftpAddress"
                        @input="areParametersDirty = true"
                    />
                </b-col>
                <b-col>
                    <p-input
                        input-type="integer"
                        left-align
                        label="FTP Port"
                        :rules="
                            isUseFtp
                                ? 'required|min_value:1|max_value:65535|integer'
                                : ''
                        "
                        v-model.number="job.parameters.ftpPort"
                        type="number"
                        @input="areParametersDirty = true"
                    />
                </b-col>
                <b-col>
                    <p-input
                        label="FTP Username"
                        :rules="isUseFtp ? 'required|max:50' : ''"
                        v-model="job.parameters.ftpUserName"
                        @input="areParametersDirty = true"
                    />
                </b-col>
                <b-col>
                    <p-input
                        label="FTP Password"
                        :rules="isUseFtp ? 'required|max:100' : ''"
                        v-model="ftpPassword"
                        type="password"
                        @input="areParametersDirty = true"
                        @focus="$event.target.select()"
                    />
                </b-col>
                <b-col>
                    <p-input
                        label="File Name"
                        rules="required|max:200"
                        v-model="job.parameters.fileName"
                        @input="areParametersDirty = true"
                    />
                    <p-checkbox
                        v-if="job.parameters.action==='Export'"
                        label="Append Date &amp; Time"
                        class="appendDateTimeCheckbox ms-3"
                        size="sm"
                        :useSwitch="true"
                        v-model="job.parameters.appendDateTime"
                    />
                </b-col>

                <b-col>
                    <p-input
                        label="FTP Directory"
                        :rules="isUseFtp ? 'max:200' : ''"
                        v-model="job.parameters.ftpDirectory"
                        @input="areParametersDirty = true"
                    />
                </b-col>
            </b-row>
            <b-row
                        class="mb-2"
                        cols="1"
                        cols-xl="2"
                        v-if="!isUseFtp"
                    >
                        <b-col>
                            <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                ref="deFile"
                                v-model="file"
                            ></b-form-file>
                        </b-col>
                    </b-row>
                    <b-row cols-lg="4"
                        class="mb-2"
                        cols="1"
                        cols-sm="2"
                        cols-xl="4">
                        <b-col>
                    <p-button
                        variant="primary"
                        v-if="!isNew"
                        @click="runJobNow"
                        :is-busy="isBusy || isSelectedJobTypeRunning"
                        >Run Now</p-button
                    >
                </b-col>
            </b-row>
        </p-card>
        <p-card>
            <div class="mt-2">
                <h4>Job Scheduler</h4>
            </div>
            <b-row>
                <b-col>
                    <b-form-group label="Occurs">
                        <b-form-radio-group
                            v-model="job.cronJobSchedules.occursSchedule"
                        >
                            <b-form-radio :value="'Daily'">Daily</b-form-radio>
                            <b-form-radio :value="'Weekly'">Weekly</b-form-radio>
                            <b-form-radio :value="'Monthly'">Monthly</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="job.cronJobSchedules.occursSchedule == 'Weekly'">
                <b-col>
                    <p-checkbox-group
                        label="Weekly"
                        :options="weekDays"
                        v-model="job.cronJobSchedules.daysOfWeek"
                    />
                </b-col>
            </b-row>
            <b-row v-if="job.cronJobSchedules.occursSchedule == 'Monthly'">
                <b-col>
                    <b-form-group label="Monthly">
                            <div class="d-inline-block mt-2">
                                    <div class="d-inline-block">
                                        Day
                                    </div>
                                <p-select
                                    class="ms-2 d-inline-block"
                                    :options="monthCount"
                                    v-model="job.cronJobSchedules.dateOfMonth"
                                />
                                <div class="d-inline-block ms-2">
                                    every month
                                </div>
                            </div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group label="Frequency">
                        <b-form-radio-group
                            v-model="job.cronJobSchedules.isOccursType"
                            @change="occursTypeChanged">
                            <b-row>
                                <b-col cols="auto">
                                    <b-form-radio
                                        :value="1"
                                        >
                                        <div class="d-inline-block me-2">
                                            Occurs Once At
                                        </div>
                                    </b-form-radio
                                    >
                                </b-col>
                                <b-col cols="1" class="ps-0"><p-timepicker
                                        v-model="job.cronJobSchedules.occursOnceTime"
                                        :disabled="job.cronJobSchedules.isOccursType !== 1"
                                        style="min-width: 130px;"
                                    />
                                </b-col>
                            </b-row>
                            <b-row class="pt-3">
                                 <b-col cols="auto">
                                    <b-row>
                                        <b-col>
                                            <span>Occurs Every</span>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <b-form-radio
                                                :value="2"
                                                >Minute</b-form-radio>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <b-form-radio
                                                :value="3"
                                                >Hour</b-form-radio>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col cols="1" rowspan="2">                                    
                                    <p-slider
                                        :disabled="job.cronJobSchedules.isOccursType == 1"
                                        v-model="job.cronJobSchedules.occursEveryTime"
                                        :mode="job.cronJobSchedules.isOccursType == 2 ? 'minute' : 'hour'"></p-slider>
                                </b-col>
                            </b-row>
                        </b-form-radio-group>                        
                    </b-form-group>
                </b-col>
            </b-row>
        </p-card>
        <b-row>
            <b-col class="text-center">
                <p-button
                    variant="primary"
                    type="submit"
                    :is-busy="isBusy"
                    :disabled="!isUseFtp"
                    >Save</p-button
                >
            </b-col>
        </b-row>
        </div>
    </p-form>
</template>

<script>
import axios from 'axios';
import NavigationGuard from '@/components/mixins/NavigationGuard.js';
import pInput from '../../components/p-input.vue';
import { defineRule } from 'vee-validate';
import utilityService from '@/services/UtilityService.js';
import StoreListManager from '@/components/mixins/StoreListManager.js';
import JSEncrypt from 'jsencrypt';
import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';
import PCheckbox from '../../components/p-checkbox.vue';
import { useAppStateStore } from '@/stores/appState.js';
import { useFeatureFlagsStore } from '@/stores/featureFlags.js';

const cronJobTypes = {
    chartOfAccounts: 1,
    serializedItems: 24,
    generalLedger: 28,
    stockLedger: 29
};

defineRule('valid_jobname', (value) => {
    var letters = new RegExp(/^[A-Za-z0-9]+$/);
    return letters.test(value) || 'Job name can only contain alphanumeric characters';
});
export default {
    components: { pInput, PCheckbox },
    mixins: [NavigationGuard,StoreListManager],
    props: {
        id: String
    },
    data() {
        return {
            cronJobTypes,
            test: 0,
            job: null,
            isBusy: false,
            jobActions: [
                { value: 'Export', text: 'Export' },
                { value: 'Import', text: 'Import' }
            ],
            filterBy:[
                'All',
                'Transaction ID',
                'Last Name',
                'First Name',
                'Customer Account #',
                'Serial #'
            ],
            generalLedgerFilterBy:[
                'All',
                'Journal Number',
                'Description'
            ],
            stockLedgerFilterBy:[
                'All',
                'Entry Type',
                'SKU',
                'Entry Reference',
                'DCC'
            ],            
            weekDays: [
                { value: 0, text: 'Sun' },
                { value: 1, text: 'Mon' },
                { value: 2, text: 'Tues' },
                { value: 3, text: 'Wed' },
                { value: 4, text: 'Thurs' },
                { value: 5, text: 'Fri' },
                { value: 6, text: 'Sat' }
            ],
            monthCount: [
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '7',
                '8',
                '9',
                '10',
                '11',
                '12',
                '13',
                '14',
                '15',
                '16',
                '17',
                '18',
                '19',
                '20',
                '21',
                '22',
                '23',
                '24',
                '25',
                '26',
                '27',
                '28',
                '29',
                '30'
            ],
            file: null,
            transactionTypeOptions: [
                { text: 'Pay In', value: 'Pay In' },
                { text: 'Pay Out', value: 'Pay Out' },
                { text: 'Refund', value: 'Refund' },
                { text: 'Sale', value: 'Sale' }
            ],
            areParametersDirty: false,
            isCheckingJobs: false,
            runningJobs: [],
            publicKey: null,
            ftpPassword: null,
            selectListOptions: {
                jobTypes: [],
                dateOption: []
            },
            isLoadingData: true
        };
    },
    watch: {
        job: NavigationGuard.$watcher,
        $route: function(to, from) {
            if (to !== from) {
                this.loadData();
            }
        },
        'job.cronJobSchedules.occursSchedule': function(value) {
            if(value !== 'Weekly')
            {
                this.job.cronJobSchedules.daysOfWeek = [];
            }
            if(value !== 'Monthly')
            {
                this.job.cronJobSchedules.dateOfMonth = null;
            }
        },
        // Was wired as @change on the b-form-radio-group, but `change` bubbled
        // from the nested time picker's native close event and reset the value
        // the user just picked. Watchers only fire on actual value changes.
        'job.cronJobSchedules.isOccursType': function() {
            if (!this.isLoadingData) {
                this.job.cronJobSchedules.occursOnceTime = '00:00';
                this.job.cronJobSchedules.occursEveryTime = this.defaultOccursEveryTime();
            }
        }
    },
    computed: {
        isNew() {
            return this.id === 'new';
        },
        isUseFtp() {
            // FTP = 1, SFTP = 2, SCP = 3, FileUpload = 4
            return this.job.parameters.transportMethod == 1 || this.job.parameters.transportMethod == 2 || this.job.parameters.transportMethod == 3;
        },
        canRenameFileAfterProcessing() {
            // Rename the source file after a successful import; only FTP/SFTP support a server-side rename.
            return this.job.parameters.action === 'Import'
                && (this.job.parameters.transportMethod == 1 || this.job.parameters.transportMethod == 2);
        },
        jobTypesOptions(){
            var jobTypesSelectList = this.selectListOptions.jobTypes;
            jobTypesSelectList = jobTypesSelectList.filter(jobType => jobType.filter === this.job.parameters.action || jobType.filter === 'Both')

            // Serialized Items is not a supported Data Exchange job type.
            jobTypesSelectList = jobTypesSelectList.filter(jobType => jobType.value != this.cronJobTypes.serializedItems);

            if(!useFeatureFlagsStore().featureFlagEnabled('Accounting')) {
                jobTypesSelectList = jobTypesSelectList.filter(jobType => 
                    jobType.value != this.cronJobTypes.chartOfAccounts 
                    && jobType.value != this.cronJobTypes.generalLedger);
            }

            return jobTypesSelectList;
        },
        runDescription() {
            let description = "";
            if (this.job.name) {
                description = this.job.description ? this.job.name + ': ' + this.job.description : this.job.name;
            } else if (this.job.description) {
                description = this.job.description;
            }

            return description;
        },
        isSelectedJobTypeRunning() {
            return this.runningJobs.some(x => x.cronJobTypeId == this.job.parameters.cronJobTypeId);
        },
        dateOptions() {
            return Object.fromEntries(
                this.selectListOptions.dateOption.map(opt => [opt.text.replace(/\s+/g, ''), opt.value])
            );
        },
        ledgerFilterBy() {
            if (this.job.parameters.cronJobTypeId === this.cronJobTypes.generalLedger) {
                return this.generalLedgerFilterBy;
            } else if (this.job.parameters.cronJobTypeId === this.cronJobTypes.stockLedger) {
                return this.stockLedgerFilterBy;
            }
            return [];
        }
    },
    methods: {
        occursTypeChanged(){
            if(!this.isLoadingData)
            {
                this.job.cronJobSchedules.occursOnceTime = '00:00';
                this.job.cronJobSchedules.occursEveryTime = this.defaultOccursEveryTime();
            }
        },
        defaultOccursEveryTime() {
            // 0 ("00") isn't a valid "Occurs Every" amount, so seed the mode's
            // minimum instead of 0: minute steps start at 15, hour must be >= 1.
            const type = this.job.cronJobSchedules.isOccursType;
            return type === 2 ? 15 : type === 3 ? 1 : 0;
        },
        async loadData() {
            this.isLoadingData = true;
            let promise = this.isNew
                ? axios.get('dataexchange/new')
                : axios.get('dataexchange', { params: { id: this.id } });

            promise.then(resp => {
                this.job = resp.data;

                this.ftpPassword = this.job.parameters.ftpPassword;
                if (!this.isNew) {
                    this.dataLoaded();
                } else {
                    this.job.parameters.transportMethod = 1; // FTP
                }
            })
            .finally(async () => {
                await this.checkRunningJobs();
                this.isLoadingData = false;
            });
            
        },
        async checkRunningJobs() {
            if (this.runningJobs.length) {
                let jobLogsQueryParams = this.runningJobs.map((x, index) => `cronJobLogIds[${index}]=${x.cronJobLogId}`).join('&');
                let jobs = await utilityService.checkDataExchangeJobsAsync(jobLogsQueryParams);
                this.runningJobs = jobs.runningJobs;
                if (this.runningJobs.length) {
                    this.isCheckingJobs = true;
                    setTimeout(this.checkRunningJobs, 60000);
                } else {
                    this.isCheckingJobs = false;
                }

                let finishedJobs = jobs.finishedJobs;
                finishedJobs.forEach(job => {
                    if (job.result == 0) {
                        this.$appError(
                                `The data exchange job '${job.description}' failed. Please review data exchange job logs for details.`
                            );
                    } else if (job.result == 1) {
                        this.$appSuccess(
                                `The data exchange job '${job.description}' completed successfully. All records were processed.`
                            );
                    } else if (job.result == 2) {
                        this.$appSuccess(
                                `The data exchange job '${job.description}' completed, but not all records were imported. Please review data exchange job logs for more details.`
                            );
                    }
                });
            }
        },
        async getPublicKey() {
            const appStateStore = useAppStateStore();
            if (appStateStore.getPublicKey === null) {
                axios.get('selectlists/publicKey').then((resp) => {
                    appStateStore.updatePublicKey(resp.data);
                    this.publicKey = resp.data;
                });
            } else {
                this.publicKey = appStateStore.getPublicKey;
            }
        },
        async onSubmit() {
            if(!this.job.cronJobSchedules.isOccursType == 2 && (this.job.cronJobSchedules.occursEveryTime==null || this.job.cronJobSchedules.occursEveryTime == 0)){
                this.$appError(
                        'Please select a time'
                    )
                return;
            }
            if(this.job.cronJobSchedules.isOccursType && (this.job.cronJobSchedules.occursOnceTime=="" || this.job.cronJobSchedules.occursOnceTime==null)){
                this.$appError(
                        'Please select a time'
                    )
                return;
            }
            if(this.job.cronJobSchedules.occursSchedule=="Weekly" && this.job.cronJobSchedules.daysOfWeek.length==0){
                this.$appError(
                        'Please select at least one day'
                    )
                return;
            }
            if(this.job.cronJobSchedules.occursSchedule=="Monthly" && this.job.cronJobSchedules.dateOfMonth == null){
                this.$appError(
                        'Please select at least one date.'
                    )
                return;
            }
            this.isBusy = true;
            // Export honors the Location criteria selector (null = All Locations).
            // Imports have no Location selector, so keep defaulting to the configured location.
            if (this.job.parameters.action !== 'Export') {
                this.job.searchSettings.locationId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
            }

            if(this.ftpPassword != "**********" && this.ftpPassword != null && this.ftpPassword != ""){
                this.job.parameters.ftpPassword = this.encryptData(this.ftpPassword);
            }
            axios
                .post('dataExchange', this.job)
                .then(response =>{
                    this.dataSaved();
                    this.$appSuccess(
                            `Data Exchange Job '${this.job.name}' saved successfully.`
                        )
                        if (this.isNew) {
                            this.$router.push('/dataexchange/' + response.data);
                        }
                        else {
                            this.loadData();
                        }
                        this.areParametersDirty = false;
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        runJobNow: async function() {
            this.isBusy = true;
            let runNowPromise = null;
            if (!(await this.$refs.form.validate())) {
                this.isBusy = false;
                return;
            }
            if(this.areParametersDirty && this.ftpPassword != "**********" && this.ftpPassword != null && this.ftpPassword != ""){
                this.job.parameters.ftpPassword = this.encryptData(this.ftpPassword);
            }

            await axios
                .post('dataExchange', this.job)
                .then(() => {
                    this.dataSaved();
                    this.areParametersDirty = false;
                });

            let runNowCommand = {
                source: "DataExchange",
                cronJobId: this.job.cronJobId,
                description: this.runDescription + ' - Manual Run',
                runDate: new Date(),
                parameters: this.job.parameters
            };
            this.job.lastRunDate = new Date();

            if (this.isUseFtp) {
                runNowPromise = axios.post('dataexchange/runjobnow', runNowCommand);
            } else {
                if (!this.file) {
                    this.$appError(
                        'Please select a file or choose FTP.'
                    );
                    this.isBusy = false;
                    this.dataLoaded();
                    return;
                } else {
                    let formData = new FormData();
                    formData.append('file', this.file);
                    formData.append(
                        'commandString',
                        JSON.stringify(runNowCommand)
                        );
                    runNowPromise = axios.post('dataexchange/runuploadjobnow', formData);
                }
            }

            await runNowPromise
                .then(resp => {
                    this.$refs.deFile?.reset();
                    this.runningJobs = resp.data;
                    this.dataLoaded();
                    if (this.runningJobs.some(x => x.isTriggered)){
                        this.$appSuccess(
                                `Data Exchange job '${runNowCommand.description}' is running. Feel free to continue working. A notification will display when the job has finished running.`
                            )
                    } else {
                        this.$appError(
                                "Another data exchange job of this type is already running. Please wait for the other job finish before starting a new job."
                            );
                    }
                    if (!this.isCheckingJobs) {
                        this.isCheckingJobs = true;
                        setTimeout(this.checkRunningJobs, 60000);
                    }
                }).catch(() => {
                    this.$refs.deFile?.reset();
                    this.dataLoaded();
                    this.$appError(
                            "There was an error running the Data Exchange job. Please contact support if the problem persists."
                        );
                }).finally(() => {
                    this.isBusy = false;
                });
        },
        deleteJob() {
            this.$bvModal
                .msgBoxConfirm('Are you sure you want to delete this Job?')
                .then(value => {
                    if (value) {
                        axios.post('dataexchange/delete', this.job).then(resp => {
                            if (resp) {
                                this.dataSaved();
                                this.$appSuccess(
                                        `Job deleted successfully.`
                                    );
                                this.$router.push('/dataexchange');
                            }
                        });
                    }
                });
         },
         clearCriteria(){
            if(this.job.parameters.action==='Import'){
                this.job.searchSettings.automatic=null;
                this.job.searchSettings.searchBy='All';
                this.job.searchSettings.posDeviceId=null;
                this.job.searchSettings.cashierId=null;
                this.job.searchSettings.transactionType=null;
                this.job.searchSettings.tenderId=null;
                this.job.searchSettings.fromDate=null;
                this.job.searchSettings.toDate=null;
            }
         },
         encryptData(data) {
            const encryptor = new JSEncrypt();
            encryptor.setPublicKey(this.publicKey);
            const encryptedData = encryptor.encrypt(data);
            return encryptedData;
        },
        onDateOptionChange(val){
            if(val == this.dateOptions.Custom){
                this.job.searchSettings.fromDate = new Date();
                this.job.searchSettings.toDate = new Date();
               return
            }
            this.job.searchSettings.fromDate = null;
            this.job.searchSettings.toDate = null;
        }
    },
    mounted: async function() {
        this.loadData();
        this.getPublicKey();
    }
};
</script>
<style scoped lang="scss">
.extra-padding {
    padding: 0 15px;
}
.active-toggle :deep(.form-check) {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    margin: 0;
    padding: 0;
    margin-top: 5px;
}
.active-toggle :deep(.form-check-label) {
    margin: 0;
    line-height: 1;
    font-size: 1rem;
    margin-top: 5px;
}
.v-center {
    display: flex;
    align-items: center;
}
.search-filter :deep(.custom-select ) {
    height: 43px;
}

.appendDateTimeCheckbox {
    margin-top: -0.75rem;
}

.box {
  background-color: lightgray;
  padding: 20px;
  text-align: center;
  border: 1px solid #ccc;
}

.full-height {
  height: 100%; /* Ensures full height */
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
